// extracted by mini-css-extract-plugin
export default {"table":"gestione-operai_table__U1apt","mini":"gestione-operai_mini__n5a56","dateModuleContainer":"gestione-operai_dateModuleContainer__aF87-"};